// extracted by mini-css-extract-plugin
export default {"footer":"_139b9cbc","footerRow":"_3deb9396","additionalLinkContainer":"_4f1175c7","navigationRefreshFooter":"_68aa766b"};